export const BOOLEAN_OPTIONS = [
    {id: 'true', value: true, name: 'True'},
    {id: 'false', value: false, name: 'False'}
];
